let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kmzYt")).then(() => parcelRequire('kzj9p'));